import { Check } from 'lucide-react';

const transformations = [
  {
    image: '/Transformation_Laura.jpeg',
    name: 'Lisa M.',
    age: 42,
    result: '-4,8 kg',
    review: 'Als Mutter von zwei Kindern hatte ich keine Zeit für komplizierte Diäten. Diese Woche hat mir gezeigt, dass es auch einfach geht. Mein Bauch ist flacher, ich habe mehr Energie und schlafe endlich wieder durch. Das Beste: Ich musste auf nichts verzichten!'
  },
  {
    image: '/vorher nacher.png',
    name: 'Sarah K.',
    age: 38,
    result: '-3,6 kg',
    review: 'Ich war skeptisch, aber die Ergebnisse sprechen für sich. Meine Hosen passen wieder, meine Haut strahlt und ich fühle mich insgesamt leichter. Die Rezepte waren lecker und ich hatte nie das Gefühl, auf etwas verzichten zu müssen.'
  },
  {
    image: '/IMG_9556 copy.JPG',
    name: 'Julia S.',
    age: 35,
    result: '-5,2 kg',
    review: 'Unglaublich, was in nur 7 Tagen möglich ist! Mein Rücken ist definierter, die Taille schmaler und ich habe keine Blähungen mehr. Am meisten überrascht hat mich, wie viel besser ich mich mental fühle. Mehr Klarheit, mehr Fokus, einfach besser!'
  }
];

export default function Results() {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 max-w-4xl mx-auto">
            Sichtbare Transformation in 7 Tagen
          </h2>
          <p className="text-xl text-gray-700 mb-12">
            Echte Menschen, echte Ergebnisse
          </p>
        </div>

        {/* Transformations Grid */}
        <div className="space-y-16 mb-16">
          {transformations.map((transformation, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden"
            >
              <div className="grid md:grid-cols-2 gap-0">
                <div className="relative">
                  <img
                    src={transformation.image}
                    alt={`Transformation von ${transformation.name}`}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {transformation.name}, {transformation.age} Jahre
                    </h3>
                    <div className="w-20 h-1 bg-green-600 rounded" />
                  </div>

                  <p className="text-lg text-gray-700 leading-relaxed italic">
                    "{transformation.review}"
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Results Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: Check, text: 'Bis zu 5kg weniger Gewicht' },
            { icon: Check, text: 'Mehr Energie & Fokus' },
            { icon: Check, text: 'Tieferer Schlaf' },
            { icon: Check, text: 'Spürbar leichteres Körpergefühl' },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            >
              <item.icon className="w-8 h-8 text-green-600 mb-3" />
              <p className="font-medium text-gray-900">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
